<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">people</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">{{ i18n["all_accounts"] }}</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">{{ i18n["manage_platfrom_accounts"] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12" class="text-center py-0" BTN>
                        <v-row class="align-center">
                          <v-col cols="12" md="4" ADD-USERS>
                              <AccountsSearch
                                @searchAccounts="searchAccounts"
                                :search_object="search_object"
                                :loading="loading"
                              />
                            </v-col>
                          <v-col cols="12" md="4" ADD-USERS>
                            <v-switch @change="filterLeads()"
                              hide-details
                              :class="`${arabic?'arFont':'enFont'}`"
                              :label="i18n['active_accounts']" v-model="active_accounts"></v-switch>
                          </v-col>
                          <v-col cols="12" md="4" ADD-USERS>
                            <v-switch @change="filterLeads()"
                              hide-details
                              :class="`${arabic?'arFont':'enFont'}`"
                              :label="i18n['accounts_with_withdrawals']" v-model="only_transactions"></v-switch>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="6" class="text-center py-0" BTN>
                        <v-btn
                          color="success"
                          block
                          :loading="loading"
                          :class="`${arabic?'arFont':'enFont'}`"
                          @click="exportResource()">
                          {{ i18n['export_accounts_list'] }}
                          <v-icon right size="15">file_download</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="6" class="text-center py-0" BTN>
                        <v-btn
                          color="primary"
                          text
                          block
                          :loading="loading"
                          :class="`${arabic?'arFont':'enFont'}`"
                          @click="dialog = true">
                          {{i18n['update_seminar_link']}}
                          <v-icon right size="15">link</v-icon>
                        </v-btn>
                        <v-dialog v-model="dialog" persistent max-width="600">
                          <v-card>
                            <v-card-title :class="`${arabic?'arFont':'enFont'}`"  style="font-size:20px">
                              {{i18n['seminar_link'] }}
                            </v-card-title>
                            <v-card-text>
                              <v-row class="align-center">
                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                                  <v-text-field
                                    :label="i18n['link']"
                                    :class="`${arabic?'arFont':'enFont'}`"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="seminar.seminar_url"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" FIELD>
                                  <v-textarea
                                    :label="i18n['note']"
                                    v-model="seminar.note"
                                    :class="`${arabic?'arFont':'enFont'}`"
                                    outlined
                                    hide-details
                                    dense
                                  ></v-textarea>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-actions :class="`${arabic?'arFont':'enFont'}`">
                              <v-spacer></v-spacer>
                              <v-btn color="primary" text @click.native="dialog = false" :class="`${arabic?'arFont':'enFont'}`">{{ i18n['cancel'] }}</v-btn>
                              <v-btn color="primary" @click.native="storeSeminar()" :class="`${arabic?'arFont':'enFont'}`">{{i18n['update']}}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-col>
                      <v-col cols="12" md="6" class="text-center py-0" BTN>
                        <v-dialog v-model="profitialog" persistent max-width="600">
                          <v-card>
                            <v-card-title :class="`${arabic?'arFont':'enFont'}`"  style="font-size:20px">{{  i18n['account_profit'] }}</v-card-title>
                            <v-card-text>
                              <v-row class="align-center">
                                <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'}`">
                                  <div>
                                    <div>{{ i18n['account_name'] }}</div>
                                    <div>{{account_.name}}</div>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'}`">
                                  <div>
                                    <div>{{ i18n["account_id"] }}</div>
                                    <div>{{account_.id}}</div>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`">
                                  <div v-for="(val, v) in Object.keys(account_profits).filter(x=>x && !x.includes('desc'))" :key="v+'val'" class="elevation-1 px-2 py-1 text-left">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on" >
                                          <div>{{val.replace(/_/g, ' ').toUpperCase()}}</div>
                                          <div>{{account_profits[val]}}</div>
                                        </div>
                                      </template>
                                      <div class="text-center" v-if="account_profits[val + '_desc']">
                                          <div>{{account_profits[val + '_desc'].replace(/_/g, ' ').toUpperCase()}}</div>
                                      </div>
                                    </v-tooltip>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <div v-bind="attrs" v-on="on">
                                        <div :class="`${arabic?'arFont':'enFont'} pb-1`">{{ i18n['total_account_profits'] }}</div>
                                        <div :class="`${arabic?'arFont':'enFont'}`">${{account_profits.total_ready}} {{ i18n['total_ready_account_profits'] }}</div>
                                        <div :class="`${arabic?'arFont':'enFont'}`">${{account_profits.total_pending}} {{ i18n['total_pending_account_profits'] }}</div>
                                      </div>
                                    </template>
                                    <div class="text-center">
                                      <div :class="`${arabic?'arFont':'enFont'} pb-1`">{{ i18n['total_account_profits'] }}</div>
                                      <div :class="`${arabic?'arFont':'enFont'}`">${{account_profits.total_ready}} {{ i18n['total_ready_account_profits'] }}</div>
                                      <div :class="`${arabic?'arFont':'enFont'}`">${{account_profits.total_pending}} {{ i18n['total_pending_account_profits'] }}</div>
                                    </div>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-actions :class="`${arabic?'arFont':'enFont'}`">
                              <v-spacer></v-spacer>
                              <v-btn color="primary" text @click.native="()=>{account_profits={};account_={};profitialog=false;}" :class="`${arabic?'arFont':'enFont'}`">{{ i18n['close'] }}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} text-center pa-2`">
                            <span v-if="resource.data" :class="`${arabic?'arFont':'enFont'}`"> {{ i18n["accounts"] }} ({{ resource.counter }})</span>
                          </v-col>
                          <v-col cols="12" md="10" :class="`${arabic?'arFont':'enFont'}`">
                            <Paging
                              :resourceSettings="resourceSettings"
                              :resource="resource"
                              @loadResource="loadResource"
                              @pageByNumber="pageByNumber"
                            />
                          </v-col>
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                            <v-expansion-panels focusable>
                              <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
                                <v-expansion-panel-header>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">
                                            {{r.name}}
                                          </span>
                                        </template>
                                        <div class="text-center">
                                          <div><img :src="r.image"></div>
                                          <div :class="`${arabic?'arFont':'enFont'}`">{{r.id}}</div>
                                        </div>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`">
                                      <div style="font-size:11px;">{{r.email}}</div>
                                      <div style="font-size:11px;">ID: {{r.id}}</div>
                                    </v-col>
                                    <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 px-2`">
                                      <v-autocomplete
                                        :items="resource.accounts"
                                        v-model="r.top_account"
                                        @change="() => updateResource(r)"
                                        :label="i18n['affiliated_with_account']"
                                        outlined
                                        dense
                                        item-value="id"
                                        hide-details
                                        :loading="loading">
                                        <template v-slot:selection="{ attr, on, item, selected }">
                                            <span v-bind="attr" :input-value="selected" v-on="on" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                                <v-chip x-small>{{ item.name }} | {{ item.id }}</v-chip>
                                            </span>
                                        </template>
                                        <template v-slot:item="{ item }">
                                            <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                                {{ item.name }} | {{ item.id }}
                                            </span>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} py-1 font-weight-bold`">
                                      <v-btn
                                        color="primary"
                                        text
                                        small
                                        block
                                        :loading="loading"
                                        :class="`${arabic?'arFont':'enFont'}`"
                                        @click="()=>{loadNums(r)}">
                                        {{ i18n['show_profits'] }}
                                        <v-icon right size="15">money</v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-divider class="pb-3"></v-divider>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-left`">
                                      <v-switch @change="updateResource(r)"
                                        hide-details
                                        :class="`${arabic?'arFont':'enFont'}`"
                                        :label="i18n['email_notifications']" v-model="r.notification_emails"></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                                      <v-tabs
                                        v-model="tab"
                                        background-color="secondary"
                                        centered
                                        dark
                                      >
                                        <v-tabs-slider></v-tabs-slider>
                                        <v-tab href="#tab-1" :class="`${arabic?'arFont':'enFont'}`">
                                          {{ i18n['payment_methods'] }}
                                        </v-tab>
                                        <v-tab href="#tab-2" :class="`${arabic?'arFont':'enFont'}`" v-if="false">
                                          {{ i18n['record_transaction'] }}
                                        </v-tab>
                                      </v-tabs>
                                      <v-tabs-items v-model="tab">
                                        <v-tab-item :value="'tab-1'">
                                          <v-card flat>
                                            <v-card-text class="py-0">
                                              <v-row class="pa-0">
                                                <v-col cols="12" v-for="(method, m) in r.methods" :key="'method-'+m" class="elevation-2 py-0 my-1">
                                                  <v-row class="py-0">
                                                    <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'}`">
                                                      {{method.name}}
                                                    </v-col>
                                                    <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'}`">
                                                      <div :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;font-size:11px;">
                                                        {{ i18n['payment_method'] }}
                                                      </div>
                                                      <div>
                                                        {{paymentMethods.filter(x=>x.slug == method.type)[0].text}}
                                                      </div>
                                                      <div v-if="ifPhoneNumber(method.type)">
                                                        {{method.phone_number}}
                                                        <v-btn
                                                            v-clipboard:copy="method.phone_number"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                      </div>
                                                      <div v-if="method.type == 'tiktok' || method.type == 'snapchat'">
                                                        {{method.payment_account }}
                                                        <v-btn
                                                            v-clipboard:copy="method.payment_account"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                      </div>
                                                      <div v-if="method.type == 'usdt'">
                                                        {{ method.payment_account }}
                                                        <v-btn
                                                              v-clipboard:copy="method.payment_account"
                                                              v-clipboard:success="clipboardSuccessHandler"
                                                              v-clipboard:error="clipboardErrorHandler"
                                                              color="success"
                                                              x-small
                                                              icon>
                                                              <v-icon size="10">content_copy</v-icon>
                                                            </v-btn>
                                                      </div>
                                                      <div v-if="method.type == 'cash_plus'">
                                                        <div>
                                                        {{ method.official_name }}
                                                          <v-btn
                                                            v-clipboard:copy="method.official_name"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>
                                                        {{ method.city }}
                                                          <v-btn
                                                            v-clipboard:copy="method.city"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                      </div>
                                                      <div v-if="method.type == 'paypal' || method.type == 'payoneer'">
                                                        {{method.paypal_email}}
                                                        <v-btn
                                                            v-clipboard:copy="method.paypal_email"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                      </div>
                                                      <div v-if="method.type == 'bank'">
                                                        <div>{{method.bank}}
                                                          <v-btn
                                                            v-clipboard:copy="method.bank"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.bank_account_name}}
                                                          <v-btn
                                                            v-clipboard:copy="method.bank_account_name"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.iban}}
                                                          <v-btn
                                                            v-clipboard:copy="method.iban"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.swift}}
                                                          <v-btn
                                                            v-clipboard:copy="method.swift"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.account_number}}
                                                          <v-btn
                                                            v-clipboard:copy="method.account_number"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.routing_number}}
                                                          <v-btn
                                                            v-clipboard:copy="method.routing_number"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.fedwire}}
                                                          <v-btn
                                                            v-clipboard:copy="method.fedwire"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.currency}}
                                                          <v-btn
                                                            v-clipboard:copy="method.currency"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.bank_address}}
                                                          <v-btn
                                                            v-clipboard:copy="method.bank_address"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.user_address}}
                                                          <v-btn
                                                            v-clipboard:copy="method.user_address"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.city}}
                                                          <v-btn
                                                            v-clipboard:copy="method.city"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                        <div>{{method.country}}
                                                          <v-btn
                                                            v-clipboard:copy="method.country"
                                                            v-clipboard:success="clipboardSuccessHandler"
                                                            v-clipboard:error="clipboardErrorHandler"
                                                            color="success"
                                                            x-small
                                                            icon>
                                                            <v-icon size="10">content_copy</v-icon>
                                                          </v-btn>
                                                        </div>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'}`">
                                                      <div :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;font-size:11px;">
                                                        {{ i18n['review_done'] }}
                                                      </div>
                                                      <div v-if="method.reviewed">
                                                        <v-icon color="success">done</v-icon>
                                                      </div>
                                                      <div v-else>
                                                        <v-icon color="error">close</v-icon>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'}`">
                                                      <div :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;font-size:11px;">
                                                        {{ i18n['has_been_approved'] }}
                                                      </div>
                                                      <div v-if="method.approved">
                                                        <v-icon color="success">done</v-icon>
                                                      </div>
                                                      <div v-else>
                                                        <v-icon color="error">close</v-icon>
                                                        <span v-if="method.reviewed" :class="`${arabic?'arFont':'enFont'}`">
                                                          {{ i18n['has_been_rejected'] }}
                                                        </span>
                                                      </div>
                                                    </v-col>
                                                  </v-row>
                                                </v-col>
                                              </v-row>
                                              <v-row class="pa-0">
                                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-0`">
                                                  <div :class="`${arabic?'arFont':'enFont'}`">Bank</div>
                                                  <div :class="`${arabic?'arFont':'enFont'}`">{{ r.bank }}
                                                    <v-btn
                                                      v-clipboard:copy="r.bank"
                                                      v-clipboard:success="clipboardSuccessHandler"
                                                      v-clipboard:error="clipboardErrorHandler"
                                                      color="success"
                                                      x-small
                                                      icon>
                                                      <v-icon size="10">content_copy</v-icon>
                                                    </v-btn>
                                                  </div>
                                                </v-col>
                                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-0`">
                                                  <div :class="`${arabic?'arFont':'enFont'}`">Account Name</div>
                                                  <div :class="`${arabic?'arFont':'enFont'}`">{{ r.bank_account_name }}
                                                    <v-btn
                                                      v-clipboard:copy="r.bank_account_name"
                                                      v-clipboard:success="clipboardSuccessHandler"
                                                      v-clipboard:error="clipboardErrorHandler"
                                                      color="success"
                                                      x-small
                                                      icon>
                                                      <v-icon size="10">content_copy</v-icon>
                                                    </v-btn>
                                                  </div>
                                                </v-col>
                                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-0`">
                                                  <div :class="`${arabic?'arFont':'enFont'}`">IBAN</div>
                                                  <div :class="`${arabic?'arFont':'enFont'}`">{{ r.iban }}
                                                    <v-btn
                                                      v-clipboard:copy="r.iban"
                                                      v-clipboard:success="clipboardSuccessHandler"
                                                      v-clipboard:error="clipboardErrorHandler"
                                                      color="success"
                                                      x-small
                                                      icon>
                                                      <v-icon size="10">content_copy</v-icon>
                                                    </v-btn>
                                                  </div>
                                                </v-col>
                                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-0`">
                                                  <div :class="`${arabic?'arFont':'enFont'}`">SWIFT</div>
                                                  <div :class="`${arabic?'arFont':'enFont'}`">{{ r.swift }}
                                                    <v-btn
                                                      v-clipboard:copy="r.swift"
                                                      v-clipboard:success="clipboardSuccessHandler"
                                                      v-clipboard:error="clipboardErrorHandler"
                                                      color="success"
                                                      x-small
                                                      icon>
                                                      <v-icon size="10">content_copy</v-icon>
                                                    </v-btn>
                                                  </div>
                                                </v-col>
                                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-0`">
                                                  <div :class="`${arabic?'arFont':'enFont'}`">Account Number</div>
                                                  <div :class="`${arabic?'arFont':'enFont'}`">{{ r.account_number }}
                                                    <v-btn
                                                      v-clipboard:copy="r.account_number"
                                                      v-clipboard:success="clipboardSuccessHandler"
                                                      v-clipboard:error="clipboardErrorHandler"
                                                      color="success"
                                                      x-small
                                                      icon>
                                                      <v-icon size="10">content_copy</v-icon>
                                                    </v-btn>
                                                  </div>
                                                </v-col>
                                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-0`">
                                                  <div :class="`${arabic?'arFont':'enFont'}`">Routing Number</div>
                                                  <div :class="`${arabic?'arFont':'enFont'}`">{{ r.routing_number }}
                                                    <v-btn
                                                      v-clipboard:copy="r.routing_number"
                                                      v-clipboard:success="clipboardSuccessHandler"
                                                      v-clipboard:error="clipboardErrorHandler"
                                                      color="success"
                                                      x-small
                                                      icon>
                                                      <v-icon size="10">content_copy</v-icon>
                                                    </v-btn>
                                                  </div>
                                                </v-col>
                                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-0`">
                                                  <div :class="`${arabic?'arFont':'enFont'}`">SWIFTwire FEDWIRE</div>
                                                  <div :class="`${arabic?'arFont':'enFont'}`">{{ r.fedwire }}
                                                    <v-btn
                                                      v-clipboard:copy="r.fedwire"
                                                      v-clipboard:success="clipboardSuccessHandler"
                                                      v-clipboard:error="clipboardErrorHandler"
                                                      color="success"
                                                      x-small
                                                      icon>
                                                      <v-icon size="10">content_copy</v-icon>
                                                    </v-btn>
                                                  </div>
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                          </v-card>
                                        </v-tab-item>
                                        <v-tab-item :value="'tab-2'" v-if="false">
                                          <v-card flat>
                                            <v-card-text class="py-0">
                                              <v-row class="pa-0">
                                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                                                  <v-text-field
                                                    :label="i18n['transaction_value']"
                                                    :class="`${arabic?'arFont':'enFont'}`"
                                                    outlined
                                                    dense
                                                    @keypress="isNumber($event)"
                                                    hide-details
                                                    v-model="transaction.value"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                                                  <v-text-field
                                                    :label="i18n['note']"
                                                    :class="`${arabic?'arFont':'enFont'}`"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    v-model="transaction.note"
                                                  ></v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                            <v-card-actions>
                                              <v-spacer></v-spacer>
                                              <v-btn color="primary" @click="recordTransaction(r)" :class="`${arabic?'arFont':'enFont'}`">
                                                {{ i18n['record_transaction'] }}
                                              </v-btn>
                                            </v-card-actions>
                                          </v-card>
                                        </v-tab-item>
                                      </v-tabs-items>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountsSearch from '@/components/AccountsSearch';
import typeMixins from '@/mixings/isType';
import Paging from '@/components/Paging';
import { format } from 'timeago.js';
import json2csv from 'json2csv';

export default {
  mixins: [typeMixins],

  components: { Paging, AccountsSearch },
  data() {
    return {
      loading: false,
      dialog: false,
      vresource: [],
      resource: [],
      search: null,
      rules: {
        required: (value) => !!value || this.i18n.required,
        email: (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n.valid_email,
      },
      resourceKeys: [

      ],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
      newResource: {},
      editing: false,
      deleting: false,
      tab: null,
      transaction: {},
      // search_term: null,
      active_accounts: true,
      seminar: {},
      page: null,
      profitialog: false,
      account_profits: {},
      account_: {},
      only_transactions: false,
      selectedAccount: null,
      search_object:{}
    };
  },
  methods: {
    async searchAccounts(){
      this.filterLeads()
    },
    async recordTransaction(r) {
      this.loading = true;
      this.transaction.account_id = r.id;
      await this.$store.dispatch('postResource', { resource: '/transactions', value: this.transaction });
      this.loading = false;
      this.transaction = {};
    },
    getFormat(d) {
      return format(d);
    },
    filterObject(item, queryText, itemText) {
      const v = Object.values(item).filter((x) => typeof x === 'string');
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (itemText && typeof itemText === 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true;
      return a;
    },
    clipboardSuccessHandler() {
      this.$emit('snackbarNotification', 'Copied', 'success');
    },
    clipboardErrorHandler() {
      this.$emit('snackbarNotification', 'Failed', 'error');
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.page = n;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${n}${this.buildFilter()}` });
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: `${this.$route.path}/search?page=${n}`, value: this.search });
        }
        this.loading = false;
      });
    },
    goTo(path) {
      this.$router.push(path).catch((x) => {});
    },
    buildFilter() {
      let filter = '';
      if (this.active_accounts) {
        filter += '&filter[active_accounts]=1';
      }
      if (this.only_transactions) {
        filter += '&filter[only_transactions]=1';
      }
      if (this.selectedAccount) {
        filter += `&filter[account_id]=${this.selectedAccount.id}`;
      }
      if (this.search_object && this.search_object.search) {
        filter += `&filter[search]=${this.search_object.search}`;
      }

      return filter;
    },
    async filterLeads() {
      await this.loadResource();
    },
    firstLoad() {
      if (this.user) {
      }
    },
    async loadNums(r) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.account_ = r;
        const lead = await this.$store.dispatch('getResource', { resource: `/leads-counters/${r.id}?&filter[account_id]=${r.id}` });
        this.account_profits = lead;
        this.profitialog = true;
        this.loading = false;
        res();
      });
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: `${this.$route.path}?page=${this.page}${this.buildFilter()}` });
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: `${this.$route.path}/search` + `?page=${this.page}`, value: this.search });
        }
        this.loading = false;
        res();
      });
    },
    async updateResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        // console.log(r)
        await this.$store.dispatch('putResource', { resource: `${this.$route.path}/${r.id}`, value: r });
        this.loadResource();
        this.loading = false;
      });
    },
    showPannel(v) {
      this[v] = true;
      const all = this.subitems.map((x) => x.value);
      all.filter((x) => x != v).forEach((x) => this[x] = false);
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')];
    },
    async exportResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        const exp = await this.$store.dispatch('getDirectResource', { resource: '/accounts-new-export' + `?${this.buildFilter()}`, blob:true });

        this.downloadExcel(exp);
        this.loading = false;
        res();
      });
    },
    downloadExcel(blobData) {
      try {
        // Create file name with today's date
        const today = new Date().toISOString().split('T')[0]; // Format YYYY-MM-DD
        const fileName = `accounts-${today}.xlsx`;

        // Create a blob URL and trigger download
        const blob = new Blob([blobData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      } catch (error) {
        console.error('Error downloading file:', error);
      }
    },
    exportSimpleData(data, name) {
      const a = json2csv.parse(data);
      // console.log(a)
      const csvContent = 'data:text/csv;charset=utf-8,';
      const encodedUri = csvContent + encodeURIComponent(a);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      const n = name || 'failed_export';
      link.setAttribute('download', `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    async storeSeminar() {
      return new Promise(async (res, rej) => {
        await this.$store.dispatch('postResource', { resource: '/store-cache/seminarlink', value: this.seminar });
        this.dialog = false;
      });
    },
    async getSeminar() {
      return new Promise(async (res, rej) => {
        const r = await this.$store.dispatch('getResource', { resource: '/get-cache/seminarlink' });
        this.seminar = r;
        res();
      });
    },

    accountChangedHandler(resource) {
      this.updateResource(resource);
    },

    AccountsSearchHandler(accountInfo) {
      this.selectedAccount = accountInfo;
      this.filterLeads();
    },
  },
  computed: {
    api() {
      return this.$store.state.settings.apiBase;
    },
    users() {
      const sa = this.$store.state.user && this.$store.state.user.role == 'superadmin';
      // console.log(sa)
      return this.$store.state.users.filter((x) => {
        if (!sa) {
          return x.superior == this.$store.state.user.level;
        } return x;
      });
    },
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    superAdmin() {
      return this.$store.state.superAdmin;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    language() {
      return this.$store.state.language;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    user() {
      return this.$store.state.user;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true;
    },
    routeTitle() {
      const main = this.$store.state.menu.filter((x) => x.path == this.$route.path);
      const sub = [].concat(...this.$store.state.menu.map((x) => x.subs)).filter((x) => x).filter((x) => x.path == this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      }
      return '';
    },
    roles() {
      return this.$store.state.userRoles;
    },
    notifications() {
      return this.$store.state.notifications.sort((a, b) => b.timestamp - a.timestamp);
    },
    paymentMethods() {
      return this.$store.state.paymentMethods;
    },
  },
  async created() {
    this.setResourceName();
    await this.loadResource();
    await this.getSeminar();
  },
};
</script>

<style>

</style>
